import { Component, HostListener, OnInit } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'dram-hero',
  templateUrl: './dram-hero.component.html',
  styleUrls: ['./dram-hero.component.css']
})
export class DramHeroComponent implements OnInit {
  icons = {
    bars: './assets/icons/bars.svg',
    whitelogo: './assets/icons/white-icon.svg',
    x: './assets/icons/x-icon.svg',
    buttonCircle: './assets/icons/button-circle.svg',
    logoBanxico: './assets/icons/footer-icon3.png',
    logoCondusef: './assets/icons/footer-icon2.png',
    logoBuro: './assets/icons/buro-logo.png',
    logo: './assets/icons/logo.svg',
    // logo: './assets/icons/favicon.png',
    perfil: './assets/icons/perfil.svg',
    money: './assets/icons/money.svg',

    whatsapp: './assets/images/whatsapp.svg',
    sphere1: './assets/images/sphere-1.png',
    sphere2: './assets/images/sphere-2.png',
    sphere3: './assets/images/sphere-3.png'
  };

  images = {
    greenLines: './assets/images/green-lines.svg'
  };

  public loaderPerfilador!: AnimationOptions;

  ngOnInit(): void {

    this.loaderPerfilador = {
      path: './assets/animations/w_hero.json',
      autoplay: true,
      loop: false,
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollY = window.scrollY;

    const sphere1 = document.querySelector('.hero-sphere-1') as HTMLElement;
    const sphere2 = document.querySelector('.hero-sphere-2') as HTMLElement;
    const sphere3 = document.querySelector('.hero-sphere-3') as HTMLElement;

    if (sphere1) sphere1.style.transform = `translateY(${scrollY * 0.1}px)`;
    if (sphere2) sphere2.style.transform = `translateY(${scrollY * 0.25}px)`;
    if (sphere3) sphere3.style.transform = `translateY(${scrollY * 0.37}px)`;
  }

  openWhatsApp() {
    const phone = '+523314115507';
    const message = encodeURIComponent('Hola. Me podrías dar más información de DRAM');
    window.open(`https://wa.me/${phone.replace('+', '')}?text=${message}`, '_blank');
  }

  downloadPDF(type: string) {
    let pdfUrl = '';
    switch (type) {
      case 'condusef':
        pdfUrl = 'assets/pdfs/condusef.pdf';
        break;
      case 'buro':
        pdfUrl = 'assets/pdfs/buro.pdf';
        break;
      case 'banxico':
        pdfUrl = 'assets/pdfs/banxico.pdf';
        break;
    }
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = pdfUrl.split('/').pop() || 'documento.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
